import { CaseKeyPersonnelDto, CreateBusinessIndustryDto, CreateCaseBusinessDto, CreateCaseCompanyDto } from '../dto';

type ExtendedCaseKeyPersonnelDto = CaseKeyPersonnelDto & {
  placeOfBirthCountry?: string;
  nationality?: string;
  contactNumberObj?: string;
};

type ExtendedCaseCreateBusinessDto = CreateCaseBusinessDto & {
  country?: string;
};

export const SINGPASS_BUSINESS_INDUSTRY_MAP_FIELD: Partial<Record<keyof CreateBusinessIndustryDto, boolean>> = {
  capitalType: true,
  issuedCapitalAmount: true,
  sharedAllotedAmount: true,
  currentPaidUpCapital: true,
  currency: true,
} as const;

export const SINGPASS_BUSINESS_MAP_FIELD: Partial<Record<keyof ExtendedCaseCreateBusinessDto, boolean>> = {
  // businessClassification: true,
  businessType: true,
  countryId: true,
  country: true,
  commencementDateOnly: true,
  natureOfBusiness: true,
  secondaryNatureOfBusiness: true,
  businessConstitution: true,
  businessOwnership: true,
  addresses: true,
  companyType: true,
  // businessActivity: true,
  businessStatus: true,
  businessExpiryDateOnly: true,
} as const;

export const SINGPASS_COMPANY_MAP_FIELD: Partial<Record<keyof CreateCaseCompanyDto, boolean>> = {
  companyName: true,
  uen: true,
  // leadId: true,
} as const;

export const SINGPASS_PERSONNEL_MAP_FIELD: Partial<Record<keyof ExtendedCaseKeyPersonnelDto, boolean>> = {
  name: true,
  nricNumber: true,
  dateOfBirthOnly: true,
  gender: true,
  addresses: true,
  placeOfBirthCountryId: true,
  placeOfBirthCountry: true,
  nationalityId: true,
  nationality: true,
  residentialStatus: true,
  // residencyId: true,
  // contactNumberObj: true,
  // email: true,
  // maritalStatus: true,
  // appointment: true,
} as const;
